module.exports = __webpack_public_path__ + "static/img/2025年历-8.2f77ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-8.png
// module id = q1io
// module chunks = 3